import Vue from 'vue'
import Router from 'vue-router'
import * as View from './views'
import {Service} from '@/main'

Vue.use(Router)

const checkAlreadyAuth = (to, from, next) => {
  if (Service.user.authenticated) {
    Service.$emit('alert-modal', '이미 로그인 되어있습니다.')
    next({name: 'dashboard'})
  }
  else next()
}

const guard = (to, from, next) => {
  // if (Service.user.authenticated && Service.user.profile.user_type === 1) next()
  if (Service.user.authenticated) next()
  else {
    Service.$emit('alert-modal', '로그인 후 이용해 주세요.')
    next({name: 'login', query: {r: to.name}})
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: View.Home,
      redirect: { name: 'management' },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          beforeEnter: guard,
          component: View.Dashboard
        },
        {
          path: 'management',
          name: 'management',
          beforeEnter: guard,
          component: View.Management,
          redirect: {name: 'management-onuse'},
          children: [
            {
              path: 'onuse',
              name: 'management-onuse',
              beforeEnter: guard,
              component: View.ManagementOnUse
            },
            {
              path: 'onprepare',
              name: 'management-onprepare',
              beforeEnter: guard,
              component: View.ManagementOnPrepare
            },
            {
              path: 'payment',
              name: 'management-payment',
              beforeEnter: guard,
              component: View.ManagementPayment
            },
            {
              path: 'notice',
              name: 'management-notice',
              beforeEnter: guard,
              component: View.ManagementNotice
            },
            {
              path: 'detail/:company_pk',
              name: 'management-detail',
              beforeEnter: guard,
              component: View.ManagementDetail,
              props: true
            },
            {
              path: 'user/:user_pk',
              name: 'management-user',
              beforeEnter: guard,
              component: View.ManagementUser,
              props: true
            }
          ]
        },
        {
          path: 'memo',
          name: 'memo',
          beforeEnter: guard,
          component: View.Memo
        },
        {
          path: 'system',
          name: 'system',
          beforeEnter: guard,
          component: View.System,
          redirect: {name: 'system-serverip'},
          children: [
            {
              path: 'serverip',
              name: 'system-serverip',
              beforeEnter: guard,
              component: View.SystemServerIP
            },
            {
              path: 'client',
              name: 'system-client',
              beforeEnter: guard,
              component: View.SystemClient
            },
            {
              path: 'polling',
              name: 'system-polling',
              beforeEnter: guard,
              component: View.SystemPolling
            },
            {
              path: 'function',
              name: 'system-function',
              beforeEnter: guard,
              component: View.SystemFunction
            }
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: checkAlreadyAuth,
      component: View.Login
    },
    {
      path: '*',
      name: 'error',
      component: View.Error
    }
  ]
})
